import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';

export const useLenderResetFundraising = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.lenderResetFundraising(payload);
      const { status, data } = response;
      if (status === 200) {
        queryClient.setQueryData([QUERY_KEYS.fundraising.lender_fr_status_by_company_id, payload.company_id], () => data);
        Notify.success({ text: t('fundraising:shared.fundraising_reset_successfully') });
        return data;
      }
      Notify.error({ text: data?.message || t('fundraising:shared.fundraising_reset_failed') });
    },
  });
};
